<template>
  <LayoutAccount>
    <template #title v-if="! showSuccessMessage">
      {{ $t('pages.password_recovery.headline_title') }}
    </template>
    <template #subtitle v-if="! showSuccessMessage">
      {{ $t('pages.password_recovery.headline_txt') }}
    </template>

    <template #mainContent>
      <div class="form-wrapper" v-if="! showSuccessMessage">
        <form @submit.prevent="recover">
          <div class="intro-section__form">
            <div class="form-group" :class="{'form-group--error': hasValidationError('email')}">
              <input
                  type="email"
                  v-model="email"
                  required
                  class="input input-lg form-control"
                  :placeholder="$t('pages.password_recovery.email')"
              />
              <span class="form-group--error__message" v-if="hasValidationError('email')">
                                {{ validationErrorsEmail }}
                            </span>
            </div>

            <div class="form-group m-0">
              <button type="submit" class="btn btn-primary m-0 w-100" :disabled="loading">
                <b-spinner small label="Loading..." v-if="loading"></b-spinner>
                <span v-else>{{ $t('pages.password_recovery.btn_submit') }}</span>
              </button>
            </div>
          </div>

          <div class="intro-section__form">
            <router-link :to="{ name: 'signup' }" class="btn btn-light w-100">
              {{ $t('pages.password_recovery.create_account') }}
            </router-link>
          </div>
        </form>
      </div>
    </template>

    <template #bottomContent>
      <div class="text-center col-12" v-if="showSuccessMessage">
        <div class="row mt-6 align-self-center justify-content-center">
          <div class="col-md-4">
              <div class="mb-3">
                <Icon name="grInbox" width="36"/>
              </div>
              <div class="mb-5">
                <h2 class="title mb-2">{{ $t('pages.password_recovery.done_headline_title') }}</h2>
                <h3 class="subtitle">{{ $t('pages.password_recovery.done_headline_txt') }}</h3>
              </div>
              <b-button variant="primary" :to="{ name: 'homepage' }">
                {{ $t('pages.password_recovery.done_btn_back') }}
              </b-button>
            </div>
          </div>
        </div>
    </template>
  </LayoutAccount>
</template>


<script>
import UserService from "@/services/User.js"
import LayoutAccount from "@/components/LayoutAccount"
import {mapGetters} from "vuex";

export default {
  components: {
    LayoutAccount
  },

  data() {
    return {
      email: "",
      loading: false,
      showSuccessMessage: false,
      validationErrors: {}
    }
  },

  computed: {
    ...mapGetters('appConfig', ['getEventOwnerId']),
    validationErrorsEmail() {
      return this.validationErrors.email[0]
    }
  },

  methods: {
    hasValidationError(fieldName) {
      return this.validationErrors.hasOwnProperty(fieldName)
    },

    recover() {
      this.loading = true
      let payload = {
        'email': this.email,
      }

      // event_owner_id is sent via axios interceptor header (pica-event-owner-id)

      UserService.resetPassword(payload)
          .then(() => {
            this.loading = false
            this.showSuccessMessage = true
          })
          .catch(error => {
            this.loading = false
            console.log('error', error.response.data)
            this.validationErrors = Object.assign({}, this.validationErrors, error.response.data)
          })
    }
  }
}
</script>
